import { useEffect, useState } from "react";
import useSWR from "swr";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fetcher } from "@/lib/api";

export function useSelectedDevice() {
  const { data: devices } = useSWR("/devices", fetcher);
  const [deviceId, setDeviceId] = useState(() => localStorage.getItem("sf-device") || "");
  useEffect(() => {
    if (devices?.length && !devices.find((d) => d.id === deviceId)) setDeviceId(devices[0].id);
  }, [devices, deviceId]);
  useEffect(() => {
    if (deviceId) localStorage.setItem("sf-device", deviceId);
  }, [deviceId]);
  return { devices: devices || [], loaded: !!devices, deviceId, setDeviceId };
}

export function DevicePicker({ devices, deviceId, onChange }) {
  if (devices.length < 2) return null;
  return (
    <Select value={deviceId} onValueChange={onChange}>
      <SelectTrigger className="w-56 rounded-full" data-testid="device-picker"><SelectValue placeholder="Server" /></SelectTrigger>
      <SelectContent>
        {devices.map((d) => <SelectItem key={d.id} value={d.id} data-testid={`device-picker-option-${d.id}`}>{d.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function TableList({ tables, selected, onSelect, renderMeta }) {
  const byDb = tables.reduce((acc, t) => {
    (acc[t.db] = acc[t.db] || []).push(t);
    return acc;
  }, {});
  return (
    <div className="surface max-h-[70vh] overflow-y-auto p-2" data-testid="data-explorer-db-tree">
      {Object.entries(byDb).map(([db, list]) => (
        <div key={db} className="mb-2">
          <div className="eyebrow px-3 pb-1 pt-2">{db}</div>
          {list.map((t) => {
            const active = selected && selected.db === t.db && selected.tbl === t.tbl;
            return (
              <button key={t.tbl} onClick={() => onSelect(t)} data-testid={`data-explorer-table-item-${t.db}-${t.tbl}`}
                className={`flex w-full items-center justify-between gap-2 rounded-xl px-3 py-2 text-left text-sm transition-colors ${active ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
                <span className="truncate font-mono text-xs">{t.tbl}</span>
                {renderMeta && <span className={`shrink-0 text-[11px] num ${active ? "text-primary-foreground/80" : "text-muted-foreground"}`}>{renderMeta(t)}</span>}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
